export const translations = {
  ar: {
    // Header
    company: 'الشركة',
    visionMission: 'رؤيتنا ورسالتنا',
    studies: 'الدراسات',
    gallery: 'المعرض',
    achievements: 'إنجازاتنا',
    
    // Hero
    heroTitle: 'شركة التوازن البيئي',
    heroSubtitle: 'شركة استشارات بيئية رائدة في المملكة العربية السعودية',
    learnMore: 'تعرف علينا',
    studyAccuracy: 'دقة الدراسة',
    fastResponse: 'سرعة الاستجابة',
    sustainableEnergy: 'طاقة مستدامة',
    
    // Vision & Mission
    vision: 'رؤيتنا',
    mission: 'رسالتنا',
    visionContent: 'رؤية شركة التوازن البيئي هي المساهمة في المملكة المستدامة حيث كل تطوير يأخذ حماية البيئة بعين الاعتبار',
    missionContent: 'مهمة شركة التوازن البيئي هي أن تكون الشركة الرائدة في مجال التنمية المستدامة من خلال استخدام دائمًا أفضل التقنيات (BAT) والمعدات والخبرات العلمية. شركة التوازن البيئي تحقق ذلك من خلال الاستفادة من معرفة وخبرة العلماء داخل منظمتنا، المملكة وعلى الصعيد الدولي. سوف نشارك معرفتنا وتعاطفنا مع البيئة من خلال برامج التثقيف المجتمعي وبناء القدرات.',
    
    // Values
    values: 'قيمنا',
    valuesTitle: 'القيم',
    environmentalBalance: 'التوازن البيئي',
    sustainability: 'الاستدامة',
    innovation: 'الابتكار',
    transparency: 'الشفافية',
    justice: 'العدالة',
    integrity: 'النزاهة',
    quality: 'الجودة',
    
    // Values Full Text
    sustainabilityFull: 'نسعى لترسيخ الوعي البيئي داخل منظومتنا ومع شركائنا والمجتمع ككل من خلال تبني الممارسات المستدامة وتحفيز الاستخدام المسؤول للموارد لبناء مستقبل أكثر وعياً واستقراراً.',
    innovationFull: 'نطور حلولًا بيئية فعالة و متواكبة مع البروتوكولات الدولية.',
    transparencyFull: 'نلتزم في كافة تعاملاتنا بالوضوح والشفافية والمصداقية، ونؤمن بأهمية تبادل المعلومات والمعرفة من خلال التواصل الفعال والمفتوح مع عملائنا وشركائنا والمجتمع.',
    justiceFull: 'نؤمن بأن العدالة هي الدعامة الأساسية لبيئة عمل مستقرة ومزدهرة. نلتزم بترسيخ مبادئ الإنصاف، وتقدير العطاء، واحترام الجهود الإنسانية في كافة تعاملاتنا مع شركائنا وفريق عملنا.',
    integrityFull: 'نلتزم بجميع القوانين والتشريعات المحلية والوطنية والدولية.',
    qualityFull: 'نكرس جهودنا لتحقيق التميز في جميع أعمالنا، ونسعى باستمرار للتحسين من خلال مراقبة وتقييم عملياتنا الداخلية لأن الجودة لدينا هي أساس لكل خدمة نقدمها، ونولي أهمية قصوى للصحة والسلامة المهنية في جميع عملياتنا.',
  },
  en: {
    // Header
    company: 'Company',
    visionMission: 'Vision & Mission',
    studies: 'Studies',
    gallery: 'Gallery',
    achievements: 'Achievements',
    
    // Hero
    heroTitle: 'Environmental Balance Company',
    heroSubtitle: 'Leading Environmental Consulting Company in Saudi Arabia',
    learnMore: 'Learn More',
    studyAccuracy: 'Precision of Studies',
    fastResponse: 'Rapid Response',
    sustainableEnergy: 'Sustainable Energy',
    
    // Vision & Mission
    vision: 'Our Vision',
    mission: 'Our Mission',
    visionContent: 'Environmental Balance Company\'s vision is to contribute to a sustainable Kingdom where every development takes environmental protection into consideration.',
    missionContent: 'Environmental Balance Company\'s mission is to be the leading company in sustainable development by always using Best Available Techniques (BAT), equipment, and scientific expertise. Environmental Balance Company achieves this by leveraging the knowledge and experience of scientists within our organization, the Kingdom, and internationally. We will share our knowledge and empathy with the environment through community education programs and capacity building.',
    
    // Values
    values: 'Our Values',
    valuesTitle: 'Values',
    environmentalBalance: 'Environmental Balance',
    sustainability: 'Sustainability',
    innovation: 'Innovation',
    transparency: 'Transparency',
    justice: 'Fairness & Equity',
    integrity: 'Integrity',
    quality: 'Quality',
    
    // Values Full Text
    sustainabilityFull: 'We strive to establish environmental awareness within our organization, with our partners, and throughout society as a whole, by adopting sustainable practices and encouraging the responsible use of resources to build a more conscious and stable future.',
    innovationFull: 'We develop effective environmental solutions that are in alignment with international protocols.',
    transparencyFull: 'We are committed to clarity, transparency, and credibility in all our dealings. We believe in the importance of exchanging information and knowledge through effective and open communication with our clients, partners, and the community.',
    justiceFull: 'We believe that fairness is the fundamental pillar of a stable and thriving work environment. We are committed to establishing the principles of equity, recognizing contributions, and respecting human efforts in all our interactions with our partners and teamwork.',
    integrityFull: 'We strictly comply with all local, national, and international laws and regulations.',
    qualityFull: 'We dedicate our efforts to achieving excellence in all our work, continuously striving for improvement by monitoring and evaluating our internal processes. For us, quality is the foundation of every service we provide, and we place the utmost importance on occupational health and safety in all our operations.',
  }
};
